
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {AuditLogListDto} from "@/api/appService";

  @Component({name:'AuditLogDetail'})
  export default class AuditLogDetail extends Vue{

    @Prop()
    item:any;

    show:boolean = false;

    handleClose(){
      this.show = false;
    }

  }
